import { RouterProvider } from 'react-router'
import { NotificationsProvider } from './components/Notifications'
import { router } from './router'

export default function App() {
  return (
    <NotificationsProvider>
      <RouterProvider router={router} />
    </NotificationsProvider>
  )
}
